module.exports = __webpack_public_path__ + "img/teamImg13.6763717d.jpg";